<template>
    <div class="page-system" @touchmove.prevent>
        <div class="bg-system"></div>
    </div>
</template>
<script>
export default {
    data() {
        return {};
    },
    created() {
        this.POINT('h5_element_imp', {
            page: 'super-成长权益页',
            tgt_event_id: 'h5_ACT_sjwh',
            tgt_name: 'h5-ACT-成长权益-升级维护弹窗'
        });
    }
};
</script>
<style lang="less" scoped>
@asserts: '../../../../assets/growth4.0/';
.page-system {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 100;
    .bg-system {
        width: 275px;
        height: 187px;
        background-image: url('@{asserts}system-update@2x.png');
        background-size: 100% 100%;
    }
}
</style>